import React from "react";
import TextWithAvatar from "./TextWithAvatar";
import ErrorCell from "./ErrorCell";
import GradeLevelsCell from "./GradeLevelsCell";

const getCustomComponent = ({ column, columnData, id }) => {
  const { uiType } = column;

  switch (uiType) {
    case "TEXT_WITH_AVATAR":
      return <TextWithAvatar columnData={columnData} id={id} />;
    case "ERROR_CELL":
      return <ErrorCell columnData={columnData} />;
    case "GRADE_LEVELS_CELL":
      return <GradeLevelsCell columnData={columnData} />;
    default:
      return null;
  }
};

export default getCustomComponent;
